export class NotificationsError extends Error {
  constructor(message) {
    super(`Notifications Error (Reason: ${message})`);
    this.name = 'NotificationsError';
  }
}